(function() {
    'use strict';
    angular.module('cabinFlightAdmin').controller('approveCabinFlightPopupCtrl', approveCabinFlightPopupCtrl);

    function approveCabinFlightPopupCtrl($uibModalInstance, modalParams, MessageService, PopupManager, cabinFlightAdminService) {

        var vm = this;
        vm.cabinFlightVersion = modalParams.cabinFlightVersion;
        vm.cabinFlightReportId = modalParams.cabinFlightReportId;
        vm.crewSchdBlockId = modalParams.crewSchdBlockId;
        vm.feedbackRequiredInCabinFlightApproval = modalParams.feedbackRequiredInCabinFlightApproval;
        vm.feedback = "";
        vm.showFormErrors = false;

        vm.approveReport = function() {
            if (vm.feedbackRequiredInCabinFlightApproval && vm.feedback.length > 0) {
              approveCabinFlight();
            } else {
                vm.showFormErrors = true;
            }
        };

        function approveCabinFlight() {
          var param = {
            "cabinFlightVersion": vm.cabinFlightVersion,
            "cabinFlightReportId": vm.cabinFlightReportId,
            "crewSchdBlockId": vm.crewSchdBlockId,
            "feedback": vm.feedback
          };
          cabinFlightAdminService.approveCabinFlight(param, function(response) {
            if (response.success) {
              MessageService.success(MessageService.MESSAGES.CABIN_FLIGHT_ADMIN.APPROVE_SUCCESS);
              $uibModalInstance.close({
                isSuccess: response.success
              });
            }
          }, function(error) {
            if (error) error = error.msg[0];
            MessageService.error(error);
          });
        }

        vm.closeMe = function() {
            PopupManager.closeModal('APPROVE_CABIN_FLIGHT_DETAILS');
        }
    }
}());
